import type { TourPage, TourSection } from "@/components/demo-tour/sections"

const agencyConsole: TourPage = { kind: "agency_console" }
const pricingGroups: TourPage = { kind: "agency_pricing_groups" }

/** Agency welcome tour — copy ported from the production Product Fruits
 *  "Welcome" and "Pricing Group" flows. Runs once per user (per agency) and
 *  hands off into the guided demo chat from the Sample Plan card. */
export const WELCOME_TOUR_SECTIONS: TourSection[] = [
  {
    id: "welcome",
    label: "Welcome",
    steps: [
      {
        page: agencyConsole,
        target: "",
        floating: true,
        title: "Welcome to Growbotik 👋",
        body: "This quick tour walks the full journey: Discovery → Impact Report → Growth Plan → Checkout, on a sample roofing company, so you know exactly what your clients experience. Let's go!",
        btn: "Next",
      },
      {
        page: agencyConsole,
        target: "agency-nav-pricing",
        action: "click",
        title: "Your prices, your links",
        body: "Pricing Groups control your markups and prospect links. Use the Sample Plan to run the guided roofer demo end-to-end.",
      },
    ],
  },
  {
    id: "pricing_guide",
    label: "Pricing guide",
    steps: [
      {
        page: pricingGroups,
        target: "pricing-sample-plan",
        title: "The Sample Plan",
        body: "The Sample Plan is a ready-made walkthrough of Discovery → Impact Report → Checkout, using example data so you can demo the product without onboarding a real business.",
        btn: "Next",
      },
      {
        page: pricingGroups,
        target: "pricing-sample-plan-demo",
        action: "click",
        title: "Run the guided demo",
        body: "Click to open the guided demo chat in a new tab and follow along — this is exactly what your prospects will experience.",
      },
    ],
  },
]
